// Mathe-Helfer. Importiert nichts (Schicht 1).

export const TAU = Math.PI * 2;

export const clamp = (v: number, a: number, b: number): number => (v < a ? a : v > b ? b : v);

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

/** Winkel `a` in Richtung `b` drehen, hoechstens um `step` (Bogenmass). */
export function turnTowards(a: number, b: number, step: number): number {
  const d = ((b - a + Math.PI * 3) % TAU) - Math.PI;
  return a + clamp(d, -step, step);
}

/**
 * Wie `Math.round` in JavaScript — die Haelfte immer Richtung +∞.
 *
 * Steht hier benannt, weil die Weltgenerierung sie braucht: Pythons `round`
 * rundet zur naechsten geraden Zahl, und genau bei `x.5` liefen die beiden
 * Seiten sonst auseinander (Gate FG-30).
 */
export const jsRound = (x: number): number => Math.floor(x + 0.5);

/** Zwei Hexfarben mischen (t = 0..1). */
export function mixHex(a: number, b: number, t: number): number {
  const r = Math.round(lerp((a >> 16) & 255, (b >> 16) & 255, t));
  const g = Math.round(lerp((a >> 8) & 255, (b >> 8) & 255, t));
  const bl = Math.round(lerp(a & 255, b & 255, t));
  return (r << 16) | (g << 8) | bl;
}

/**
 * Zwei Hexfarben kanalweise multiplizieren.
 *
 * Genau das, was zwei Tints uebereinander auf der GPU taeten — und der Grund,
 * warum es sie gibt: ein Sprite traegt nur **einen** Tint. Wer einem Brocken
 * seine Erzfarbe und zugleich die Schadensfaerbung geben will, rechnet die
 * Mischfarbe vorher hier aus.
 */
export function mulHex(a: number, b: number): number {
  const r = (((a >> 16) & 255) * ((b >> 16) & 255)) / 255;
  const g = (((a >> 8) & 255) * ((b >> 8) & 255)) / 255;
  const bl = ((a & 255) * (b & 255)) / 255;
  return (Math.round(r) << 16) | (Math.round(g) << 8) | Math.round(bl);
}

/** `"#c3bcae"` -> `0xc3bcae`. */
export const hexToInt = (hex: string): number => parseInt(hex.slice(1), 16);
